"use client";
import { Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import { SimpleList } from "@/components/list";

type ContentPointProps = {
  text: string;
  points: string[];
};

const ContentPoints = ({ text, points }: ContentPointProps) => {
  const textVariant = useTextVariant();
  return (
    <Stack gap={4}>
      <Text variant={textVariant} color="text.100">
        {text}
      </Text>
      <SimpleList points={points} />
    </Stack>
  );
};

export const FAQS = [
  {
    title: "What are the main advantages of using Hosted NetBox?",
    content:
      "Hosted NetBox solutions offer simplified deployment, automatic scaling, enhanced security, and reduced operational overhead, allowing businesses to focus on network optimization and automation without managing the underlying infrastructure.",
  },
  {
    title: "Can I customize the functionality of my Hosted NetBox instance?",
    content:
      "Yes, Hosted NetBox platforms typically offer extensive customization options, including plugins and API integrations, enabling businesses to tailor the system to their specific operational requirements.",
  },
  {
    title: "How does Hosted NetBox ensure data security?",
    content:
      "Data security is maintained through encryption at rest and in transit, regular backups, access controls, and compliance with industry-standard security practices, safeguarding sensitive network information.",
  },
  {
    title:
      "Is it possible to integrate Hosted NetBox with other network management tools?",
    content:
      "Absolutely. Hosted NetBox solutions are designed to integrate seamlessly with various network management and automation tools, providing a cohesive ecosystem for infrastructure management.",
  },
  {
    title: "What kind of support is available for Hosted NetBox services?",
    content:
      "Providers offer expert support for deployment, configuration, performance optimization, and ongoing maintenance, ensuring the solution operates efficiently and effectively.",
  },
  {
    title: "How does Hosted NetBox handle scalability during network expansion?",
    content:
      "Hosted NetBox services offer elastic scalability, allowing resources to be adjusted dynamically based on network growth and varying workloads, ensuring consistent performance.",
  },
  {
    title: "What is the difference between Hosted NetBox and self-hosted NetBox?",
    content:
      "Hosted NetBox is managed by a service provider who handles infrastructure, maintenance, and scaling, reducing operational complexity. In contrast, a self-hosted NetBox requires in-house resources to manage all aspects of deployment and upkeep.",
  },
  {
    title: "Can Hosted NetBox support compliance with industry regulations?",
    content:
      "Yes, Hosted NetBox services are designed with security features and compliance certifications to help businesses meet industry-specific regulatory requirements.",
  },
  {
    title: "How does Hosted NetBox support multi-site network management?",
    content: (
      <ContentPoints
        text="Hosted NetBox allows businesses to manage multiple data centers and remote offices from a centralized dashboard, providing:"
        points={[
          "Global visibility into network infrastructure across locations.",
          "Centralized IP Address Management (IPAM) for all sites.",
          "Automated device inventory tracking across multiple regions.",
        ]}
      />
    ),
  },
  {
    title: "What industries benefit the most from Hosted NetBox?",
    content:
      "Hosted NetBox is ideal for IT infrastructure teams, data centers, service providers, and enterprises that require automated network documentation, IP address tracking, and infrastructure visualization.",
  },
  {
    title: "Can I migrate my existing NetBox data to a Hosted NetBox solution?",
    content:
      "Yes! Hosted NetBox providers offer seamless data migration tools that help businesses move their existing NetBox data to a cloud-hosted environment with minimal downtime and full data integrity.",
  },
  {
    title: "How do I get started with Hosted NetBox on Onemind?",
    content:
      "Contact Onemind for a free consultation and get a customized Hosted NetBox solution with scalable resources, automated backups, and expert support.",
  },
];
